// Block free / personal email providers on lead capture forms.
// Keep this list focused on the most common consumer providers.
const PERSONAL_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.fr',
  'ymail.com',
  'rocketmail.com',
  'hotmail.com',
  'hotmail.co.uk',
  'hotmail.fr',
  'outlook.com',
  'outlook.fr',
  'live.com',
  'live.fr',
  'msn.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'aim.com',
  'protonmail.com',
  'proton.me',
  'pm.me',
  'gmx.com',
  'gmx.de',
  'gmx.net',
  'mail.com',
  'mail.ru',
  'yandex.com',
  'yandex.ru',
  'zoho.com',
  'fastmail.com',
  'tutanota.com',
  'tutamail.com',
  'tuta.io',
  'hey.com',
  'qq.com',
  '163.com',
  '126.com',
  'sina.com',
  'naver.com',
  'free.fr',
  'orange.fr',
  'wanadoo.fr',
  'laposte.net',
  'sfr.fr',
  'bbox.fr',
  'neuf.fr',
  'numericable.fr',
  'web.de',
  't-online.de',
  'libero.it',
  'virgilio.it',
  'tin.it',
  'btinternet.com',
  'sky.com',
  'rogers.com',
  'shaw.ca',
  'comcast.net',
  'verizon.net',
  'att.net',
  'sbcglobal.net',
  'bellsouth.net',
  'cox.net',
  'earthlink.net',
]);

export function isPersonalEmail(email: string): boolean {
  const trimmed = email.trim().toLowerCase();
  const at = trimmed.lastIndexOf('@');
  if (at === -1) return false;
  const domain = trimmed.slice(at + 1);
  return PERSONAL_EMAIL_DOMAINS.has(domain);
}

export const PERSONAL_EMAIL_MESSAGE =
  'Please use your work email. Personal email addresses (Gmail, Outlook, Yahoo, etc.) are not accepted.';
